import { useTranslation } from 'react-i18next';
import { Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

type ConfirmDialogProps = {
    open: boolean;
    message?: string;
    onCancel: () => void;
    onConfirm: () => void;
}

const Confirm = ({
    open,
    message,
    onCancel,
    onConfirm
}: ConfirmDialogProps) => {

    const { t } = useTranslation();

    return (
        <Dialog
            //disableBackdropClick={true}
            disableEscapeKeyDown={true}
            maxWidth="xs"
            open={open}
        >
            <DialogTitle>{t('Conferma')}</DialogTitle>
            <DialogContent>
                <Typography>{message || t('Conferma elimina')}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    {t('Annulla')}
                </Button>
                <Button onClick={onConfirm} color="primary">
                    {t('Ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default Confirm